import { useState, useEffect, useInsertionEffect } from 'react';
import {
    Button, TextField, Box,
    Backdrop, Stack, Typography,
    InputLabel, MenuItem, FormControl, Select,
    CircularProgress, Paper
} from '@mui/material';
import Swal from 'sweetalert2';

import CustomButton from "../custom_components/CustomButton";
import CustomModalHeader from "../custom_components/CustomModalHeader";

const EditUser = ({ open, onClose, onRefresh, user }) => {
    const apiUrl = process.env.REACT_APP_API_URL;

    const [fullName, setFullName] = useState("");
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [userRole, setUserRole] = useState("Admin");

    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (user) {
            setFullName(user.FullName ?? "");
            setUserName(user.UserName ?? "");
            setPassword(user.UserPass ?? "");
            setUserRole(user.UserRole ?? "");
        }
    }, [user]);

    const handleEditUser = async () => {

        setIsSaving(true);

        try {
            const response = await fetch(`${apiUrl}manage_users/edit_user.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    userId: user.id,
                    fullName: fullName,
                    userName: userName,
                    password: password,
                    userRole: userRole,
                })
            });

            const result = await response.json();

            if (result.status === 'success') {
                Swal.fire({ text: result.message, icon: "info" }).then((result) => {
                    if (result.isConfirmed) {
                        onRefresh();
                    }
                });
            } else if (result.status === 'error') {
                Swal.fire({ text: result.message, icon: "error" });
            }
        } catch (error) {
            Swal.fire({ title: 'Error saving user!', text: error, icon: "error" });
            console.error('Error saving list:', error);
        } finally {
            setFullName("");
            setUserName("");
            setPassword("");
            setUserRole("Admin");
            setIsSaving(false);
            onClose();
        }
    };

    return (
        <Backdrop
            aria-hidden="false"
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backdropFilter: "blur(1px)",
            }}
        >
            <Paper
                sx={{
                    width: 400,
                    p: 3,
                    borderRadius: 2,
                    position: "relative",
                    overflow: "hidden",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "4px",
                        background: "#2e3489"
                    }
                }}
            >
                <CustomModalHeader
                    title="Edit User"
                    subtitle="Update user information"
                    onClose={onClose}
                />

                <Stack direction="column" gap={2} mt={3}>
                    <TextField
                        label="Full Name"
                        size='small'
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                    />
                    <TextField
                        label="User Name"
                        size='small'
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                    />
                    <TextField
                        label="Password"
                        size='small'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <FormControl fullWidth size='small'>
                        <InputLabel id="demo-simple-select-label">Age</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={userRole}
                            label="Age"
                            onChange={(e) => setUserRole(e.target.value)}
                        >
                            <MenuItem value="CEO">CEO</MenuItem>
                            <MenuItem value="Manager">Manager</MenuItem>
                            <MenuItem value="Admin">Admin</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>

                <Stack direction="row" spacing={2} mt={3} justifyContent="flex-end">
                    <CustomButton
                        label="Cancel"
                        variant="outlined"
                        hoverColor="#d14249"
                        onClick={onClose}
                    />
                    <CustomButton
                        label={isSaving ? "Saving..." : "Save"}
                        disabled={isSaving}
                        startIcon={isSaving && <CircularProgress size={16} color="inherit" />}
                        onClick={handleEditUser}
                    />
                </Stack>
            </Paper>

        </Backdrop>
    );
};

export default EditUser;
